import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton, SkeletonColorSchemesEnum} from '../../skeleton';

/*
 * Style.
 */

const StyledConversationListSkeletonContainerDiv = styled.div`
  display: flex;
  flex-flow: column;
  border-top: none;
  padding: 0;
`;

const StyledLineSkeleton = styled(Skeleton)`
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledLineWithTopMarginSkeleton = styled(StyledLineSkeleton)`
  margin-top: 8px;
`;

/*
 * Component.
 */

export const ConversationListSkeleton: FC = () => (
  <StyledConversationListSkeletonContainerDiv>
    <StyledLineWithTopMarginSkeleton height="70px" scheme={SkeletonColorSchemesEnum.GREY10} />
    <StyledLineWithTopMarginSkeleton height="70px" scheme={SkeletonColorSchemesEnum.GREY10} />
  </StyledConversationListSkeletonContainerDiv>
);
